import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { NavigationMobileWrapper, NavigationWrapper } from '@Header/Navigation/Navigation.styles';
import { isPhoneOrTabletDevice } from '../SupportDropdown/ducks/selectors';
import About from './About';
import HowItWorks from './HowItWorks';
import Mobile from './Mobile';
import SupportDropdown from './SupportDesktop';

class Navigation extends PureComponent {
  static propTypes = {
    environment: PropTypes.string.isRequired,
  };

  render() {
    const { environment } = this.props;

    return (
      <>
        <NavigationWrapper>
          <HowItWorks />
          <About />
          <SupportDropdown environment={environment} />
        </NavigationWrapper>
        <NavigationMobileWrapper>
          <Mobile environment={environment} />
        </NavigationMobileWrapper>
      </>
    );
  }
}

const mapStateToProps = state => ({
  isPhoneOrTablet: isPhoneOrTabletDevice(state),
});

export default connect(mapStateToProps)(Navigation);
